import { render, staticRenderFns } from "./QuestionFontSize.vue?vue&type=template&id=6a7a755e&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardHeader/QuestionFontSize?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardHeader/QuestionFontSize?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports